
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/org/[orgSlug]/content/[contentSlug]",
      function () {
        return require("private-next-pages/org/[orgSlug]/content/[contentSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/org/[orgSlug]/content/[contentSlug]"])
      });
    }
  